import React from "react";
import { Navigate } from "react-router-dom";
import { hasAccess } from "../utils/permissionHelper";

const PrivateRoute = ({ children, module, action }) => {
  const isAuthenticated = localStorage.getItem("auth") === "true";
  const user = JSON.parse(localStorage.getItem("user"));

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (module && !hasAccess(user, module, action)) {
    return <Navigate to="/403" replace />;
  }

  return children;
};

export default PrivateRoute;
